<template>
  <div class="girese wrapper-content w-100">
    <h1>{{title}}</h1>
    <div>
      <LmComponentLoading v-if="isLoading" fixed />
      <LmBreadcrumb v-if="showBreadcrumb" />
      <div class="cuerpoGirese" id="printContainer">
        <img :src="collapsedLogoImg" alt="" height="46" class="float-left mr-2 logoImg">
        <div class="tituloGirese text-center">MUNICIPALIDAD DE VICENTE LÓPEZ</div>
        <div class="correspondeGirese text-center">CORRESPONDE AL TRÁMITE NRO: {{itemDetail.expediente}}</div>
        <hr>
        <div class="segundoCuerpoGirese">
          <div class="agregadoGirese" v-if="itemDetail.principal">AGREGADO AL EXPEDIENTE NRO.: {{itemDetail.principal}}</div>
          <div class="iniciadorGirese">INICIADOR: {{itemDetail.iniciador}} {{itemDetail.otros}}</div>
          <div class="oficinaOrigenGirese">OFICINA ORIGEN: {{itemDetail.oficina_origen}} - {{itemDetail.nombre_oficina_origen}}</div>
          <div>CLASIFICACION: {{itemDetail.clasificacion}}</div>
          <div v-if="itemDetail.subclasificaciones">SUBCLASIFICACIONES: {{itemDetail.subclasificaciones}}</div>
          <div class="cuentaGirese" v-if="itemDetail.cuentas">NRO CUENTA: {{itemDetail.cuentas}}</div>
          <div class="PadronGirese" v-if="itemDetail.padrones">NRO PADRON: {{itemDetail.padrones}}</div>
          <div class="cuentaGirese" >GIRESE A: {{itemDetail.oficina_destino}} - {{itemDetail.detalle_oficina_destino}}</div>
          <div class="recibidoFechaGirese" >POR RECIBIDO EN LA FECHA: {{itemDetail.fecha_inicio}}</div>
          <div class="lugarFechaGirese">VICENTE LÓPEZ, {{itemDetail.fecha_inicio}}</div>
        </div>
      </div>
      <form
        @submit.prevent="submit"
        novalidate
        class="position-relative">
        <LmButton
          v-if="showPDFButton"
          type="button"
          @click.native="print()"
          :value="$t('print')"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click.native="goBackBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmComponentLoading from '@/components/LmComponentLoading'

export default {
  components: {
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmComponentLoading
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      form: {},
      formIsProcessing: false,
      isLoading: true
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail']),
    ...mapState('settings', ['collapsedLogoImg']),
    apiCall () {
      return {
        path: this.newOrEditEndpointUri,
        id: this.isOnEditMode ? this.$route.params.id : null
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    downloadCsvFileName: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      default: true
    },
    showPDFButton: {
      type: Boolean,
      required: false,
      default: false
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    goBackRoute: {
      type: String,
      required: false
    },
    // La uri tanto para obtener la configuracion desde settings como
    // para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newOrEditEndpointUri: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions('commons', ['deleteItem', 'getItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    goBackBtn () {
      this.$router.go(-1)
    },
    print () {
      const prevTitle = document.title
      document.title = `girese-${this.itemDetail.expediente}`
      this.$htmlToPaper('printContainer')
      document.title = prevTitle
    }
  },
  created () {
    (async () => {
      await this.getItemDetail(this.apiCall)
        .catch(error => {
          console.log(error)
          this.$router.replace({ name: '404' })
        })
      this.isLoading = false
    })()
  }
}
</script>

<style lang="sass" scoped>
  #printContainer
    .tituloGirese
      font-size: 40px
    .correspondeGirese
      font-size: 22px
    .segundoCuerpoGirese
      font-size: 18px
      .recibidoFechaGirese
        margin-top: 50px
      .cuentaGirese
        margin-top: 50px
      .iniciadorGirese
        margin-top: 50px
        margin-bottom: 50px
      .agregadoGirese
        margin-top: 50px
      .lugarFechaGirese
        margin-top: 200px
    h4
      margin-bottom: 30px
    h6
      margin-left: 20px
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
  form
    padding-top: 50px
</style>
